var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePinkBgAckScreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 768,
    viewBox: "0 0 360 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5680_136903)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 768,
    fill: "#FEFDF9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5680_136903)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 768,
    fill: "#FFF8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.065 127.021H266.734C266.539 127.021 266.353 126.943 266.215 126.806C266.077 126.668 266 126.481 266 126.286C265.988 123.238 266.84 120.248 268.457 117.666C270.074 115.083 272.39 113.013 275.135 111.696C277.88 110.379 280.942 109.869 283.965 110.226C286.988 110.583 289.847 111.791 292.211 113.711C294.345 109.398 297.544 105.703 301.504 102.975C305.463 100.248 310.053 98.5782 314.838 98.1254C319.622 97.6725 324.443 98.4512 328.843 100.388C333.243 102.324 337.076 105.354 339.979 109.19C343.228 106.426 347.198 104.647 351.421 104.064C355.645 103.481 359.947 104.117 363.822 105.897C367.697 107.677 370.985 110.528 373.298 114.115C375.612 117.702 376.856 121.875 376.884 126.145C376.907 126.26 376.903 126.379 376.871 126.492C376.839 126.605 376.781 126.709 376.701 126.795C376.621 126.881 376.521 126.946 376.411 126.985C376.3 127.025 376.182 127.037 376.065 127.021ZM267.383 125.551H375.332C375.192 121.546 373.909 117.666 371.636 114.368C369.362 111.071 366.192 108.495 362.502 106.946C358.812 105.397 354.756 104.939 350.814 105.628C346.872 106.316 343.21 108.121 340.261 110.829C340.185 110.898 340.096 110.952 339.999 110.986C339.902 111.02 339.799 111.034 339.697 111.027C339.596 111.012 339.498 110.976 339.411 110.923C339.324 110.87 339.248 110.799 339.189 110.716C336.465 106.877 332.777 103.827 328.5 101.873C324.222 99.9182 319.504 99.1291 314.824 99.5849C310.145 100.041 305.668 101.725 301.846 104.469C298.024 107.212 294.993 110.917 293.058 115.209C292.942 115.415 292.749 115.567 292.522 115.633C292.406 115.648 292.288 115.639 292.176 115.604C292.064 115.57 291.961 115.513 291.873 115.435C289.82 113.561 287.278 112.311 284.543 111.829C281.808 111.348 278.992 111.655 276.425 112.716C273.858 113.776 271.644 115.546 270.043 117.819C268.442 120.091 267.519 122.773 267.383 125.551Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-2.71607 234.784C33.8296 226.936 69.6368 226.58 106.791 227.962C120.633 228.477 136.081 231.654 149.734 234.008C162.673 236.239 174.974 240.176 187.546 243.829C208.519 249.923 227.234 262.249 246.847 271.551C262.052 278.762 277.496 288.479 291.725 297.677C302.12 304.397 313.856 309.251 324.815 315.106C331.858 318.869 338.68 323.585 345.408 327.734C355.449 333.926 366.03 340.555 376.47 345.955C380.505 348.042 388.512 356.083 393.106 355.096",
    stroke: "#FF3E79",
    strokeWidth: 135,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5680_136903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 768,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5680_136903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 768,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePinkBgAckScreen);
export default __webpack_public_path__ + "static/media/mobile-pink-bg-ack-screen.1c463d0c936e2b989ccda59a8a33e9e4.svg";
export { ForwardRef as ReactComponent };